"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentPageProvider = exports.useCurrentPageContext = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const AppRouter_1 = require("src/configeek_assets/src/components/common/AppRouter");
const use_custom_compare_1 = require("use-custom-compare");
const lodash_1 = __importDefault(require("lodash"));
const CurrentPageContext = React.createContext(undefined);
const useCurrentPageContext = () => {
    const context = React.useContext(CurrentPageContext);
    if (!context) {
        throw new Error("useCurrentPageContext must be used within a CurrentPageContext.Provider");
    }
    return context;
};
exports.useCurrentPageContext = useCurrentPageContext;
const UNKNOWN_PAGE = { identifier: "unknown", isExact: false };
const CurrentPageProvider = (props) => {
    const [page, setPage] = (0, react_1.useState)(UNKNOWN_PAGE);
    let newPage = UNKNOWN_PAGE;
    const routeMatchHome = (0, react_router_dom_1.useRouteMatch)(AppRouter_1.PATH__HOME);
    const routeMatchProject = (0, react_router_dom_1.useRouteMatch)(AppRouter_1.PATH__PROJECT);
    if (routeMatchHome && routeMatchHome.isExact) {
        newPage = {
            identifier: "home",
            isExact: routeMatchHome.isExact,
        };
    }
    else if (routeMatchProject) {
        newPage = {
            identifier: "project",
            isExact: routeMatchProject.isExact,
            ...routeMatchProject.params
        };
    }
    (0, use_custom_compare_1.useCustomCompareEffect)(() => {
        setPage(newPage);
    }, [newPage], lodash_1.default.isEqual);
    const value = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        page
    }), [page], lodash_1.default.isEqual);
    return React.createElement(CurrentPageContext.Provider, { value: value }, props.children);
};
exports.CurrentPageProvider = CurrentPageProvider;
